import { VisibilityFilters } from 'actions'
import { actions } from './actions'

const employerActiveFilter = (state = VisibilityFilters.SHOW_ACTIVE, action) => {
  switch (action.type) {
    case actions.set:
      return action.employerActiveFilter
    default:
      return state
  }
}

export default employerActiveFilter



// WEBPACK FOOTER //
// ./src/store/employer-active-filter/reducer.js